import { useContext } from "react"
import { LanguageToolContext } from "./LanguageTool"


export const useLanguageTool = () => {
    const context = useContext(LanguageToolContext)

    if (context === undefined) {
        throw new Error('useLanguageTool must be used within a LanguageToolProvider')
    }
    
    return context
}
